/** KPI — metric card with icon, label, value and sub-text. */
import React from 'react';

export default function KPI({ icon, accent, label, value, sub, alert }) {
  return (
    <div className={`sq__kpi sq__kpi--${accent}${alert ? ' sq__kpi--alert' : ''}`}>
      <div className="sq__kpi-top">
        <span className="sq__kpi-icon">{icon}</span>
        <span className="sq__kpi-label">{label}</span>
      </div>
      <div className="sq__kpi-val">{value}</div>
      <div className="sq__kpi-sub">{sub}</div>
    </div>
  );
}
